var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/utils/thermostatSchedule.js
var require_thermostatSchedule = __commonJS({
  "server/utils/thermostatSchedule.js"(exports, module) {
    var DAY_MINUTES = 24 * 60;
    var timeToMinutes = (time) => {
      if (!time) {
        return 0;
      }
      const [h, m] = time.split(":").map(Number);
      return h * 60 + (m || 0);
    };
    var minutesToTime = (mins) => {
      const m = (mins % DAY_MINUTES + DAY_MINUTES) % DAY_MINUTES;
      return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
    };
    var applySlotToDay = (existingDaySlots, dayOfWeek, newStart, newEnd, newPreset, newKey, excludeKey) => {
      const clampedEnd = Math.min(newEnd, DAY_MINUTES);
      const overflowMins = newEnd > DAY_MINUTES ? newEnd - DAY_MINUTES : 0;
      const slots = excludeKey ? existingDaySlots.filter((s) => s.key !== excludeKey) : existingDaySlots;
      const sortedByEnd = slots.slice().sort((a, b) => {
        const aEnd = timeToMinutes(a.end_time) || DAY_MINUTES;
        const bEnd = timeToMinutes(b.end_time) || DAY_MINUTES;
        return aEnd - bEnd;
      });
      let predecessorKey = null;
      let predecessorEnd = -1;
      sortedByEnd.forEach((s) => {
        const sEnd = timeToMinutes(s.end_time) || DAY_MINUTES;
        if (sEnd <= newStart && sEnd > predecessorEnd) {
          predecessorEnd = sEnd;
          predecessorKey = s.key;
        }
      });
      const adjusted = [];
      slots.forEach((s) => {
        const sStart = timeToMinutes(s.start_time);
        const sEndRaw = timeToMinutes(s.end_time);
        const sEnd = sEndRaw === 0 ? DAY_MINUTES : sEndRaw;
        if (sEnd <= newStart || sStart >= clampedEnd) {
          if (s.key === predecessorKey && sEnd < newStart) {
            adjusted.push({ ...s, end_time: minutesToTime(newStart) });
          } else {
            adjusted.push(s);
          }
        } else if (sStart < newStart && sEnd > clampedEnd) {
          adjusted.push({ ...s, end_time: minutesToTime(newStart) });
          adjusted.push({ ...s, start_time: minutesToTime(clampedEnd), key: `split-${s.key}` });
        } else if (sStart < newStart) {
          adjusted.push({ ...s, end_time: minutesToTime(newStart) });
        } else if (sEnd > clampedEnd) {
          adjusted.push({ ...s, start_time: minutesToTime(clampedEnd) });
        }
      });
      adjusted.push({
        day_of_week: dayOfWeek,
        start_time: minutesToTime(newStart),
        end_time: minutesToTime(clampedEnd),
        preset: newPreset,
        key: newKey
      });
      const overflowSlot = overflowMins > 0 ? {
        start_time: "00:00",
        end_time: minutesToTime(overflowMins),
        preset: newPreset,
        key: `overflow-${newKey}`
      } : null;
      return { fixedSlots: adjusted, overflowSlot };
    };
    var mergeIntoSlots = (allSlots, dayOfWeek, taggedFixed, overflowSlot) => {
      if (!overflowSlot) {
        return [...allSlots.filter((s) => s.day_of_week !== dayOfWeek), ...taggedFixed];
      }
      const nextDay = (dayOfWeek + 1) % 7;
      const overflowEnd = timeToMinutes(overflowSlot.end_time) || DAY_MINUTES;
      const nextDayKept = [];
      allSlots.filter((s) => s.day_of_week === nextDay).forEach((s) => {
        const sStart = timeToMinutes(s.start_time);
        const sEndRaw = timeToMinutes(s.end_time);
        const sEnd = sEndRaw === 0 ? DAY_MINUTES : sEndRaw;
        if (sStart >= overflowEnd) {
          nextDayKept.push(s);
          return;
        }
        if (sEnd > overflowEnd) {
          nextDayKept.push({ ...s, start_time: minutesToTime(overflowEnd) });
        }
      });
      const otherDays = allSlots.filter((s) => s.day_of_week !== dayOfWeek && s.day_of_week !== nextDay);
      return [...otherDays, ...taggedFixed, ...nextDayKept, { ...overflowSlot, day_of_week: nextDay }];
    };
    var readDayAsEntered = (allSlots, dayOfWeek) => {
      const nextDay = (dayOfWeek + 1) % 7;
      const daySlots = allSlots.filter((s) => s.day_of_week === dayOfWeek);
      const nextDaySlots = allSlots.filter((s) => s.day_of_week === nextDay);
      return daySlots.map((slot) => {
        const endsAtMidnight = timeToMinutes(slot.end_time) === 0;
        if (!endsAtMidnight) {
          return slot;
        }
        const overflow = nextDaySlots.find(
          (s) => timeToMinutes(s.start_time) === 0 && s.preset === slot.preset && timeToMinutes(s.end_time) !== 0
        );
        if (!overflow) {
          return slot;
        }
        return { ...slot, end_time: overflow.end_time, overnight: true };
      });
    };
    var copyDayOntoDays = (allSlots, sourceDay, targetDays, makeKey) => {
      const sourceSlots = readDayAsEntered(allSlots, sourceDay).slice().sort((a, b) => {
        return timeToMinutes(a.start_time) - timeToMinutes(b.start_time);
      });
      let result = allSlots.filter((s) => !targetDays.includes(s.day_of_week));
      const daysToFill = targetDays.includes((sourceDay + 1) % 7) ? [...targetDays, sourceDay] : targetDays;
      daysToFill.forEach((targetDay) => {
        sourceSlots.forEach((slot) => {
          const start = timeToMinutes(slot.start_time);
          const rawEnd = timeToMinutes(slot.end_time) || DAY_MINUTES;
          const end = slot.overnight ? rawEnd + DAY_MINUTES : rawEnd;
          const existing = result.filter((s) => s.day_of_week === targetDay);
          const { fixedSlots, overflowSlot } = applySlotToDay(
            existing,
            targetDay,
            start,
            end,
            slot.preset,
            makeKey(),
            null
          );
          const taggedFixed = fixedSlots.map((s) => ({ ...s, day_of_week: targetDay }));
          result = mergeIntoSlots(result, targetDay, taggedFixed, overflowSlot);
        });
      });
      return result;
    };
    var parseEnd = (timeStr) => {
      const v = timeToMinutes(timeStr);
      return v === 0 ? DAY_MINUTES : v;
    };
    var WEEKDAY_INDEX = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
    var getCurrentDayAndMinutes = (now = /* @__PURE__ */ new Date(), timezone = null) => {
      let weekday = null;
      let hours = null;
      let minutes = null;
      if (timezone) {
        try {
          const parts = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            weekday: "short",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
          }).formatToParts(now);
          const get = (type) => parts.find((part) => part.type === type).value;
          const parsedWeekday = WEEKDAY_INDEX[get("weekday")];
          const parsedHours = parseInt(get("hour"), 10) % 24;
          const parsedMinutes = parseInt(get("minute"), 10);
          weekday = parsedWeekday;
          hours = parsedHours;
          minutes = parsedMinutes;
        } catch (e) {
        }
      }
      if (weekday === null) {
        weekday = (now.getDay() + 6) % 7;
        hours = now.getHours();
        minutes = now.getMinutes();
      }
      return {
        dayOfWeek: weekday,
        yesterdayOfWeek: (weekday + 6) % 7,
        currentMinutes: hours * 60 + minutes
      };
    };
    var findMatchingSlot = (todaySlots, yesterdaySlots, currentMinutes) => {
      const matchedToday = todaySlots.find((slot) => {
        const slotStart = timeToMinutes(slot.start_time);
        const slotEnd = parseEnd(slot.end_time);
        return slotEnd > slotStart && currentMinutes >= slotStart && currentMinutes < slotEnd;
      });
      if (matchedToday) {
        return matchedToday;
      }
      const matchedOvernightStart = todaySlots.find((slot) => {
        const slotStart = timeToMinutes(slot.start_time);
        const slotEnd = timeToMinutes(slot.end_time);
        return slotEnd < slotStart && currentMinutes >= slotStart;
      });
      if (matchedOvernightStart) {
        return matchedOvernightStart;
      }
      const matchedOvernightEnd = yesterdaySlots.find((slot) => {
        const slotStart = timeToMinutes(slot.start_time);
        const slotEnd = timeToMinutes(slot.end_time);
        return slotEnd < slotStart && currentMinutes < slotEnd;
      });
      return matchedOvernightEnd || null;
    };
    var findMatchingPreset = (todaySlots, yesterdaySlots, currentMinutes) => {
      const slot = findMatchingSlot(todaySlots, yesterdaySlots, currentMinutes);
      return slot ? slot.preset : null;
    };
    var findCurrentTransition = (transitions, dayOfWeek, currentMinutes) => {
      if (!transitions || transitions.length === 0) {
        return null;
      }
      const sorted = [...transitions].sort(
        (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
      );
      const nowPosition = dayOfWeek * DAY_MINUTES + currentMinutes;
      const positionOf = (transition) => transition.day_of_week * DAY_MINUTES + timeToMinutes(transition.time);
      let current = null;
      sorted.forEach((transition) => {
        if (positionOf(transition) <= nowPosition) {
          current = transition;
        }
      });
      return current || sorted[sorted.length - 1];
    };
    var findNextTransition = (transitions, dayOfWeek, currentMinutes) => {
      const current = findCurrentTransition(transitions, dayOfWeek, currentMinutes);
      if (!current) {
        return null;
      }
      const sorted = [...transitions].sort(
        (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
      );
      const index = sorted.findIndex(
        (transition) => transition.day_of_week === current.day_of_week && transition.time === current.time
      );
      return sorted[(index + 1) % sorted.length];
    };
    var timezoneOffsetMinutes = (instant, timezone = null) => {
      if (timezone) {
        try {
          const parts = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            hourCycle: "h23"
          }).formatToParts(new Date(instant));
          const get = (type) => parseInt(parts.find((part) => part.type === type).value, 10);
          const wallClock = Date.UTC(get("year"), get("month") - 1, get("day"), get("hour") % 24, get("minute"));
          return Math.round((wallClock - (instant - instant % (60 * 1e3))) / (60 * 1e3));
        } catch (e) {
        }
      }
      return -new Date(instant).getTimezoneOffset();
    };
    var nextTransitionTimestamp = (transitions, now = /* @__PURE__ */ new Date(), timezone = null) => {
      if (!transitions || transitions.length === 0) {
        return null;
      }
      const { dayOfWeek, currentMinutes } = getCurrentDayAndMinutes(now, timezone);
      const next = findNextTransition(transitions, dayOfWeek, currentMinutes);
      const nowPosition = dayOfWeek * DAY_MINUTES + currentMinutes;
      const nextPosition = next.day_of_week * DAY_MINUTES + timeToMinutes(next.time);
      const minutesAway = nextPosition > nowPosition ? nextPosition - nowPosition : 7 * DAY_MINUTES - nowPosition + nextPosition;
      const startOfMinute = now.getTime() - now.getTime() % (60 * 1e3);
      const sameOffset = startOfMinute + minutesAway * 60 * 1e3;
      const offsetNow = timezoneOffsetMinutes(startOfMinute, timezone);
      const moved = (instant) => sameOffset + (offsetNow - timezoneOffsetMinutes(instant, timezone)) * 60 * 1e3;
      const first = moved(sameOffset);
      const second = moved(first);
      if (first === second) {
        return first;
      }
      let before = Math.min(first, second);
      let after = Math.max(first, second);
      const offsetAfter = timezoneOffsetMinutes(after, timezone);
      while (after - before > 60 * 1e3) {
        const middle = before + Math.floor((after - before) / (2 * 60 * 1e3)) * 60 * 1e3;
        if (timezoneOffsetMinutes(middle, timezone) === offsetAfter) {
          after = middle;
        } else {
          before = middle;
        }
      }
      return after;
    };
    var calendarDaysAhead = (instant, now = /* @__PURE__ */ new Date()) => {
      const midnight = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate()).getTime();
      return Math.round((midnight(new Date(instant)) - midnight(now)) / (24 * 60 * 60 * 1e3));
    };
    var daysUntilPoint = (point, dayOfWeek, currentMinutes) => {
      const days = (point.day_of_week - dayOfWeek + 7) % 7;
      return days === 0 && timeToMinutes(point.time) <= currentMinutes ? 7 : days;
    };
    var carriedPresetByDay = (transitions) => {
      const byDay = {};
      for (let day = 0; day < 7; day += 1) {
        byDay[day] = null;
      }
      if (!transitions || transitions.length === 0) {
        return byDay;
      }
      for (let day = 0; day < 7; day += 1) {
        const ownPoints = transitions.filter((transition) => transition.day_of_week === day).map((transition) => timeToMinutes(transition.time)).sort((a, b) => a - b);
        const startsOnItsOwnPoint = ownPoints.length > 0 && ownPoints[0] === 0;
        const inherited = startsOnItsOwnPoint ? null : findCurrentTransition(transitions, day, 0);
        const lastOfWeek = [...transitions].sort(
          (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
        )[transitions.length - 1];
        const wrapsOntoItself = inherited && inherited.day_of_week === lastOfWeek.day_of_week && inherited.time === lastOfWeek.time;
        byDay[day] = inherited && (inherited.day_of_week !== day || wrapsOntoItself) ? {
          preset: inherited.preset,
          day: inherited.day_of_week,
          until: ownPoints.length > 0 ? ownPoints[0] : DAY_MINUTES
        } : null;
      }
      return byDay;
    };
    module.exports = {
      findCurrentTransition,
      findNextTransition,
      carriedPresetByDay,
      nextTransitionTimestamp,
      calendarDaysAhead,
      daysUntilPoint,
      applySlotToDay,
      mergeIntoSlots,
      readDayAsEntered,
      copyDayOntoDays,
      timeToMinutes,
      minutesToTime,
      parseEnd,
      getCurrentDayAndMinutes,
      findMatchingSlot,
      findMatchingPreset,
      DAY_MINUTES
    };
  }
});

// server/utils/thermostatRanges.js
var require_thermostatRanges = __commonJS({
  "server/utils/thermostatRanges.js"(exports, module) {
    var { timeToMinutes, minutesToTime, DAY_MINUTES } = require_thermostatSchedule();
    var STOP_PRESET = "off";
    function transitionsToRanges(transitions) {
      if (!transitions || transitions.length === 0) {
        return [];
      }
      const sorted = [...transitions].sort(
        (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
      );
      const ranges = [];
      sorted.forEach((transition, index) => {
        const next = sorted[(index + 1) % sorted.length];
        const startMinutes = timeToMinutes(transition.time);
        const endMinutes = timeToMinutes(next.time);
        const wrapsWholeWeek = sorted.length === 1;
        const endsNextDay = wrapsWholeWeek || next.day_of_week !== transition.day_of_week || endMinutes <= startMinutes;
        ranges.push({
          day_of_week: transition.day_of_week,
          start_time: transition.time,
          end_time: wrapsWholeWeek ? transition.time : next.time,
          preset: transition.preset,
          ends_next_day: endsNextDay
        });
      });
      return ranges;
    }
    function rangesToTransitions(ranges) {
      if (!ranges || ranges.length === 0) {
        return [];
      }
      const opens = /* @__PURE__ */ new Map();
      const closes = /* @__PURE__ */ new Map();
      const key = (day, time) => `${day}-${time}`;
      ranges.forEach((range) => {
        const startKey = key(range.day_of_week, range.start_time);
        opens.set(startKey, { day_of_week: range.day_of_week, time: range.start_time, preset: range.preset });
        if (range.preset === STOP_PRESET) {
          return;
        }
        const startMinutes = timeToMinutes(range.start_time);
        const endMinutes = timeToMinutes(range.end_time);
        const endsNextDay = endMinutes <= startMinutes;
        const endDay = endsNextDay ? (range.day_of_week + 1) % 7 : range.day_of_week;
        closes.set(key(endDay, range.end_time), {
          day_of_week: endDay,
          time: range.end_time,
          preset: STOP_PRESET
        });
      });
      const transitions = [...opens.values()];
      closes.forEach((close, closeKey) => {
        if (!opens.has(closeKey)) {
          transitions.push(close);
        }
      });
      const sorted = transitions.sort(
        (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
      );
      const coversMondayMorning = ranges.some((range) => {
        if (range.day_of_week === 0 && timeToMinutes(range.start_time) === 0) {
          return true;
        }
        const crossesMidnight = timeToMinutes(range.end_time) <= timeToMinutes(range.start_time);
        if (crossesMidnight) {
          return range.day_of_week === 6;
        }
        return false;
      });
      if (!coversMondayMorning) {
        sorted.unshift({ day_of_week: 0, time: "00:00", preset: STOP_PRESET });
      }
      return sorted;
    }
    function isAllDayRange(range) {
      return Boolean(range) && range.start_time === "00:00" && range.end_time === "00:00";
    }
    function mergeTouchingRanges(ranges) {
      const WEEK = 7 * DAY_MINUTES;
      const openAt = (range) => range.day_of_week * DAY_MINUTES + timeToMinutes(range.start_time);
      const closeAt = (range) => {
        const start = openAt(range);
        const end = range.day_of_week * DAY_MINUTES + timeToMinutes(range.end_time);
        return end <= start ? end + DAY_MINUTES : end;
      };
      const fitsInADay = (first, second) => closeAt(second) + (closeAt(second) < openAt(first) ? WEEK : 0) - openAt(first) <= DAY_MINUTES;
      const sorted = [...ranges].sort((a, b) => openAt(a) - openAt(b));
      const merged = [];
      sorted.forEach((range) => {
        const previous = merged[merged.length - 1];
        if (previous && previous.preset === range.preset && closeAt(previous) === openAt(range) && fitsInADay(previous, range)) {
          merged[merged.length - 1] = { ...previous, end_time: range.end_time };
          return;
        }
        merged.push(range);
      });
      if (merged.length > 1) {
        const last = merged[merged.length - 1];
        const first = merged[0];
        if (last.preset === first.preset && closeAt(last) % WEEK === openAt(first) && fitsInADay(last, first)) {
          merged[0] = { ...last, end_time: first.end_time };
          merged.pop();
        }
      }
      return merged;
    }
    var WEEK_MINUTES = 7 * DAY_MINUTES;
    function weekInterval(range) {
      const start = range.day_of_week * DAY_MINUTES + timeToMinutes(range.start_time);
      const length = (timeToMinutes(range.end_time) - timeToMinutes(range.start_time) + DAY_MINUTES) % DAY_MINUTES;
      return [start, start + (length === 0 ? DAY_MINUTES : length)];
    }
    function trimRangesAround(ranges, candidate, ignoredKey = null) {
      const [candidateStart, candidateEnd] = weekInterval(candidate);
      const cuts = [-WEEK_MINUTES, 0, WEEK_MINUTES].map((shift) => [candidateStart + shift, candidateEnd + shift]);
      const result = [];
      ranges.forEach((range) => {
        if (range.key === ignoredKey) {
          result.push(range);
          return;
        }
        const [start, end] = weekInterval(range);
        let pieces = [[start, end]];
        cuts.forEach(([cutStart, cutEnd]) => {
          pieces = pieces.flatMap(([from, to]) => {
            if (cutEnd <= from || to <= cutStart) {
              return [[from, to]];
            }
            return [
              [from, Math.min(to, cutStart)],
              [Math.max(from, cutEnd), to]
            ].filter(([a, b]) => a < b);
          });
        });
        if (pieces.length === 1 && pieces[0][0] === start && pieces[0][1] === end) {
          result.push(range);
          return;
        }
        const dayStart = range.day_of_week * DAY_MINUTES;
        pieces.forEach(([from, to]) => {
          const piece = {
            ...range,
            start_time: minutesToTime(from % DAY_MINUTES),
            end_time: minutesToTime(to % DAY_MINUTES)
          };
          if (from === start) {
            result.push(piece);
            return;
          }
          result.push({
            ...piece,
            key: `${range.key}-tail-${from - dayStart}`,
            day_of_week: Math.floor(from % WEEK_MINUTES / DAY_MINUTES)
          });
        });
      });
      return result;
    }
    function weekCoverage(ranges) {
      return ranges.flatMap((range) => {
        const [start, end] = weekInterval(range);
        return end > WEEK_MINUTES ? [
          [start, WEEK_MINUTES],
          [0, end - WEEK_MINUTES]
        ] : [[start, end]];
      });
    }
    function subtractIntervals(intervals, cuts) {
      return cuts.reduce(
        (pieces, [cutStart, cutEnd]) => pieces.flatMap(
          ([from, to]) => cutEnd <= from || to <= cutStart ? [[from, to]] : [
            [from, Math.min(to, cutStart)],
            [Math.max(from, cutEnd), to]
          ].filter(([a, b]) => a < b)
        ),
        intervals
      );
    }
    function copyDayRanges(ranges, sourceDay, targetDays, makeKey = (day, index) => `copy-${day}-${index}`) {
      const targets = [...new Set(targetDays)].filter((day) => day !== sourceDay).sort((a, b) => a - b);
      const own = ranges.filter((range) => range.day_of_week === sourceDay);
      const firstOwnStart = Math.min(DAY_MINUTES, ...own.map((range) => timeToMinutes(range.start_time)));
      const previousDay = (day) => (day + 6) % 7;
      const pastMidnight = (range) => weekInterval(range)[1] - (range.day_of_week + 1) * DAY_MINUTES;
      const inherited = ranges.filter((range) => range.day_of_week === previousDay(sourceDay) && pastMidnight(range) > 0).map((range) => ({ length: Math.min(firstOwnStart, pastMidnight(range)), preset: range.preset }));
      let result = [];
      ranges.forEach((range) => {
        if (!targets.includes(range.day_of_week)) {
          result.push(range);
          return;
        }
        const tails = trimRangesAround([range], { day_of_week: range.day_of_week, start_time: "00:00", end_time: "00:00" });
        result = [...result, ...tails.filter((tail) => !targets.includes(tail.day_of_week))];
      });
      const copies = targets.flatMap(
        (day) => own.map((range, index) => ({
          key: makeKey(day, index),
          day_of_week: day,
          start_time: range.start_time,
          end_time: range.end_time,
          preset: range.preset
        }))
      );
      const crossesMidnight = (range) => pastMidnight(range) > 0;
      const addCopies = (list) => list.forEach((copy) => {
        result = [...trimRangesAround(result, copy), copy];
      });
      addCopies(copies.filter(crossesMidnight));
      const gaps = subtractIntervals([[0, WEEK_MINUTES]], weekCoverage(ranges));
      const isGap = (minute) => gaps.some(([from, to]) => from <= minute && minute < to);
      targets.forEach((day) => {
        const midnight = day * DAY_MINUTES;
        let free = subtractIntervals([[midnight, midnight + firstOwnStart]], weekCoverage(result));
        if (!targets.includes(previousDay(day)) && isGap((midnight + WEEK_MINUTES - 1) % WEEK_MINUTES)) {
          free = subtractIntervals(
            free,
            gaps.filter(([from, to]) => from <= midnight && midnight < to)
          );
        }
        inherited.forEach((night, index) => {
          free.filter(([from]) => from < midnight + night.length).forEach(([from, to]) => {
            result.push({
              key: makeKey(day, own.length + index),
              day_of_week: day,
              start_time: minutesToTime(from - midnight),
              end_time: minutesToTime(Math.min(to, midnight + night.length) - midnight),
              preset: night.preset
            });
          });
        });
      });
      addCopies(copies.filter((range) => !crossesMidnight(range)));
      return mergeTouchingRanges(result);
    }
    function removeRangeAndFill(ranges, key) {
      const removed = ranges.find((range) => range.key === key);
      const remaining = ranges.filter((range) => range.key !== key);
      if (!removed || remaining.length === 0) {
        return remaining;
      }
      const WEEK = 7 * DAY_MINUTES;
      const openAt = (range) => range.day_of_week * DAY_MINUTES + timeToMinutes(range.start_time);
      const closeAt = (range) => {
        const start = openAt(range);
        const end = range.day_of_week * DAY_MINUTES + timeToMinutes(range.end_time);
        return end <= start ? end + DAY_MINUTES : end;
      };
      const removedStart = openAt(removed);
      let predecessor = remaining[0];
      let smallestDistance = Infinity;
      remaining.forEach((range) => {
        const distance = ((removedStart - closeAt(range)) % WEEK + WEEK) % WEEK;
        if (distance < smallestDistance) {
          smallestDistance = distance;
          predecessor = range;
        }
      });
      if (smallestDistance > 0) {
        return mergeTouchingRanges(remaining);
      }
      const filler = { ...removed, key: `${predecessor.key}-fill-${removed.key}`, preset: predecessor.preset };
      return mergeTouchingRanges([...remaining, filler]);
    }
    module.exports = {
      transitionsToRanges,
      rangesToTransitions,
      isAllDayRange,
      mergeTouchingRanges,
      trimRangesAround,
      copyDayRanges,
      removeRangeAndFill,
      STOP_PRESET
    };
  }
});
const __cjsModule = require_thermostatRanges();
export default __cjsModule;
export const transitionsToRanges = __cjsModule.transitionsToRanges;
export const rangesToTransitions = __cjsModule.rangesToTransitions;
export const isAllDayRange = __cjsModule.isAllDayRange;
export const mergeTouchingRanges = __cjsModule.mergeTouchingRanges;
export const trimRangesAround = __cjsModule.trimRangesAround;
export const copyDayRanges = __cjsModule.copyDayRanges;
export const removeRangeAndFill = __cjsModule.removeRangeAndFill;
export const STOP_PRESET = __cjsModule.STOP_PRESET;
